// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import 'lib-flexible'

import './load-config'

Vue.config.productionTip = false

//初始化
if(window.Statistics){
  window.Statistics('init', {
      Vue, // vue2 传 Vue ,
      //app, //vue3 传createApp创建的实例 app 
      router,// 路由对象实例
      sentry: {
        dsn: 'https://9180a678607a47afba049a84ec7a7db6@ss.haier.net/1204', // 替换上报地址
        // 环境信息
        environment:"prod",  //请配置为 dev 、test、stage、prod 中一种
        // 通过环境变量注入对应版本号
        release: process.env.FRAPPE_VERSION,  // 配置参考 “约定-版本控制约定”
      }  
  });
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js